import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '../../../../../environments/environment';
import { BodyListResponse } from '../../../../core/models/general/body-list-response';
import { PonderacionDTO } from '../../../../core/models/evaluacion/ponderacion-DTO';
import { BodyResponse } from '../../../../core/models/general/body-response';

const API_URL = environment.apiUrlEvaluacion;

@Injectable()
export class PonderacionService {
    header = new Headers({ 'Content-Type': 'application/json' });

    constructor(private http: HttpClient) {}

    getPonderacionService() {
        return this.http.get<BodyListResponse<PonderacionDTO>>(
            API_URL + '/api/v1/ponderacion/todos'
        );
    }

    guardarPonderacionService(ponderacionDTO: PonderacionDTO) {
        return this.http.post(API_URL + '/api/v1/ponderacion', ponderacionDTO);
    }

    getPonderacionPorCodigoPonderacionService(codigoPonderacion: String) {
        return this.http.get<BodyResponse<PonderacionDTO>>(
            API_URL + '/api/v1/ponderacion/' + codigoPonderacion
        );
    }
}
